import axiosPost from "./axiosPost";

export const usuarioBasicosGet = async ({
    usuarioNroDeDocumento,
    usuarioSexo,
    usuarioFechaDeNacimiento,
    tipoDeDocumentoCod
}, credentials) => {
    const body = {
        service: "UsuarioBasicosGet",
        params: {
            usuarioNroDeDocumento,
            usuarioSexo,
            usuarioFechaDeNacimiento,
            tipoDeDocumentoCod,
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
